import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['video', 'overlay'];

  // Hide the branded overlay and hand off to the browser's native controls,
  // which give us a pause button, progress bar, and fullscreen toggle for free
  // (and are fully keyboard- and screen-reader-accessible).
  play() {
    this.videoTarget.play();
    this.videoTarget.controls = true;
    this.overlayTarget.hidden = true;
    // The overlay button we just hid had focus; move it to the video so
    // keyboard users stay in context and the native controls are reachable.
    this.videoTarget.focus();
  }

  // Return to the branded poster state once playback finishes.
  reset() {
    this.videoTarget.controls = false;
    this.videoTarget.currentTime = 0;
    this.overlayTarget.hidden = false;
  }
}
